import React from 'react';
import {
  FieldValues,
  UnpackNestedValue,
  UseFormMethods,
} from 'react-hook-form';
import classNames from 'classnames';
import { RiLock2Line } from 'react-icons/ri';
import { Button } from '../Input/Button/Button';
import styles from './styles.module.scss';
import { LinkButton } from '../Input/Button/LinkButton';
import emailImage from '../../assets/email.png';

type Props<T extends FieldValues> = {
  className?: string;
  disabled?: boolean;
  form: UseFormMethods<T>;
  title: React.ReactNode | string;
  subTitle?: React.ReactNode | string;
  cardTitle?: React.ReactNode | string;
  cardSubTitle?: React.ReactNode | string;
  prevStep: (() => void) | false;
  onFormSubmit: (update: UnpackNestedValue<T>) => Promise<void>;
  children: React.ReactNode;
  nextLabel?: string;
  showSecure?: boolean;
  contanctInfo?: boolean;
  subFooterText?: string;
};

export function DealerLaunchFormCardLayout<T extends FieldValues>({
  className,
  form,
  title,
  subTitle,
  cardTitle,
  cardSubTitle,
  disabled,
  prevStep,
  onFormSubmit,
  children,
  nextLabel = 'Continue',
  showSecure,
  contanctInfo,
  subFooterText,
}: Props<T>) {
  return (
    <div className={classNames(styles.stepContainer, className)}>
      <div className={styles.stepTitle}>{title}</div>
      {subTitle && <div className={styles.stepSubtitle}>{subTitle}</div>}
      <form
        onSubmit={form.handleSubmit((update) => onFormSubmit(update))}
        className={styles.stepCard}
      >
        {cardTitle && (
          <h1>
            {cardTitle}
            {showSecure ? (
              <span className={styles.secureIcon}>
                <RiLock2Line /> Secure
              </span>
            ) : null}
          </h1>
        )}
        {cardSubTitle && <p>{cardSubTitle}</p>}
        {children}
        <div className={styles.pageNav}>
          {prevStep && (
            <Button
              className={styles.pageNavButton}
              disabled={disabled}
              label="Previous"
              onClick={prevStep}
            />
          )}
          <div className="spacer" />
          <Button
            className={styles.pageNavButton}
            label={nextLabel}
            disabled={disabled}
            type="submit"
            variant="primary"
            loading={form.formState.isSubmitting}
          />
        </div>
      </form>
      <div className={styles.contactFooter}>
        {subFooterText ? <p>{subFooterText}</p> : null}
        {contanctInfo ? (
          <>
            <p>Questions? Contact Us</p>
            <LinkButton
              className={styles.contactLine}
              to="mailto:dealersetup@upstart.com"
              variant="minimal"
              rawLink
            >
              <img src={emailImage} alt="Email" />
              dealersetup@upstart.com
            </LinkButton>
          </>
        ) : null}
      </div>
    </div>
  );
}
